import type { CreateTrailerInput, Page, TrailerListQuery, TransferAssetOwnershipInput, UpdateTrailerInput } from '@chukua/common';
import { api } from '../../lib/api';
import { toListParams } from '../../lib/list-params';

export interface TrailerListItem {
  id: string;
  registration: string;
  typeCode: string;
  capacityTonnes: number;
  axleCount: number;
  isActive: boolean;
  createdAt: string;
}

export interface TrailerView {
  id: string;
  registration: string;
  typeCode: string;
  capacityTonnes: number;
  axleCount: number;
  isSkeletal: boolean;
  isFlatRack: boolean;
  isReefer: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export function listTrailers(query: TrailerListQuery): Promise<Page<TrailerListItem>> {
  return api<Page<TrailerListItem>>(`/trailers?${toListParams(query)}`);
}

export async function createTrailer(input: CreateTrailerInput): Promise<void> {
  await api<void>('/trailers', { method: 'POST', body: JSON.stringify(input) });
}

export function getTrailer(id: string): Promise<TrailerView> {
  return api<TrailerView>(`/trailers/${id}`);
}

export async function updateTrailer(id: string, input: UpdateTrailerInput): Promise<void> {
  await api<void>(`/trailers/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function activateTrailer(id: string): Promise<void> {
  await api<void>(`/trailers/${id}/activate`, { method: 'POST' });
}

export async function deactivateTrailer(id: string): Promise<void> {
  await api<void>(`/trailers/${id}/deactivate`, { method: 'POST' });
}

export interface TrailerOwnershipPeriod {
  id: string;
  ownerId: string;
  ownerName: string;
  effectiveFrom: string;
  effectiveTo: string | null;
}

export function listTrailerOwnershipPeriods(trailerId: string): Promise<TrailerOwnershipPeriod[]> {
  return api<TrailerOwnershipPeriod[]>(`/trailers/${trailerId}/ownership-periods`);
}

export async function transferTrailerOwnership(trailerId: string, input: TransferAssetOwnershipInput): Promise<void> {
  await api<void>(`/trailers/${trailerId}/ownership-periods/transfer`, { method: 'POST', body: JSON.stringify(input) });
}
